require('./Object.assign');
require('./requestAnimationFrame');
require('./Math.sign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/pixi.js/src/polyfill/index.js
 ** module id = 161
 ** module chunks = 0
 **/